/**
 * 🔴 **그림 주소에 도장을 찍는다** — 고친 그림이 바로 내려가게.
 *
 * `/art/` 는 파일 이름이 고정이라 그림을 고쳐도 주소가 그대로다. 그래서 CDN 과 브라우저가
 * **네 시간** 동안 옛 사본을 준다. 배포도 성공이고 서버 파일도 새것인데 아이 화면만 옛 그림이다
 * (2026-08-26 옆모습, 2026-08-27 그레그 흰색 발밑 — 두 번 다 여기서 시간을 썼다).
 *
 * 그래서 **파일 내용의 도장**(`?v=여덟자리`)을 붙인다. 고친 그림만 주소가 바뀌고,
 * 안 고친 317장은 캐시 그대로다 — 학교 공유기 하나에 태블릿 서른 대가 걸려 있다.
 *
 * ## 🔴 모르는 주소는 안 건드린다
 * 표에 없으면 **그대로 돌려준다.** 관리자가 올린 `/assets/…`(R2)와 바깥 주소는 여기 상관이 없고,
 * 표가 비어도 지금까지와 똑같이 동작해야 한다(불변식 3).
 * 이미 `?` 가 붙은 주소도 그대로 둔다 — 두 번 붙이면 서버가 못 알아본다.
 */
import ART_HASHES from "virtual:art-hashes";

/** 검사에서 표를 갈아 끼울 수 있게 — 운영에서는 빌드가 채운 표 하나뿐이다. */
let table: Record<string, string> = ART_HASHES;

export function setArtHashesForTest(t: Record<string, string>): void {
  table = t;
}

export function artUrl(url: string): string;
export function artUrl(url: string | undefined): string | undefined;
export function artUrl(url: string | undefined): string | undefined {
  if (!url || url.includes("?") || !url.startsWith("/art/")) return url;
  const v = table[url];
  return v ? `${url}?v=${v}` : url;
}
